module.exports = __webpack_public_path__ + "static/mentor2-aca7583f6b1ec9aa0bea03fb28f9ef82.png";